import React from 'react';
import GroupLogo from '../assets/images/Group.png';

const UpgradeMessageModal = ({ setPlanFailed, leadsCount }) => {
	return (
		<div className='modalDivWraper Upgrade activated'>
			<div className='innerModalWraper'>
				<div className='fieldWrapers modalFields textCenter'>
					<img src={GroupLogo} className='modalImgsHead' alt='' />
					<p className='textAuto'>
						{`You could have tagged ${leadsCount} members in your post automatically but unfortunately you cant run this automation.`}
					</p>
					<p className='textAuto bold'>
						Upgrade now to experience the full feature and functionality.
					</p>
					<div className='buttonWraper'>
						<a
							href='mailto:sales@tier5.us'
							className='confirmBtn'
							style={{ textDecoration: 'none' }}
						>
							Upgrade
						</a>
						<button
							className='cancelBtn upgrades'
							onClick={(e) => setPlanFailed(false)}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpgradeMessageModal;
